var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { getWidth, getTopLeft } from 'ol/extent';
import TileLayer from 'ol/layer/Tile';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import React from 'react';
import PropTypes from 'prop-types';
import { ensureMap } from '../../hocs/ensureMap';
import { provideMapState } from '../../hocs/provideMapState';

/**
 * Web Map Tile Service (WMTS) Prototype
 *
 */
export var WmtsLayer = function (_React$Component) {
  _inherits(WmtsLayer, _React$Component);

  function WmtsLayer() {
    _classCallCheck(this, WmtsLayer);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  WmtsLayer.prototype.componentDidMount = function componentDidMount() {
    this.addLayer(this.props);
  };

  WmtsLayer.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.map === this.props.map && this.uriCompare(prevProps.uri, this.props.uri) && this.uriCompare(prevProps.uris, this.props.uris) && prevProps.layerName === this.props.layerName) {
      return;
    }

    map.removeLayer(map._layers[this.id]);
    delete map._layers[this.id];
    this.addLayer(this.props);
  };

  WmtsLayer.prototype.uriCompare = function uriCompare(uri, nextUri) {
    if (Array.isArray(uri) && Array.isArray(nextUri)) {
      return uri.join(',') === nextUri.join(',');
    }
    return uri === nextUri;
  };

  WmtsLayer.prototype.addLayer = function addLayer(props) {
    var map = props.map,
        layerName = props.layerName,
        uri = props.uri,
        uris = props.uris,
        attributions = props.attributions,
        useBaat = props.useBaat,
        onPreCompose = props.onPreCompose,
        onPostCompose = props.onPostCompose,
        baatToken = props.baatToken,
        projCode = props.projCode,
        opacity = props.opacity,
        maxZoom = props.maxZoom,
        minZoom = props.minZoom,
        zIndex = props.zIndex,
        format = props.format,
        style = props.style,
        numberOfZoomResolutions = props.numberOfZoomResolutions,
        crossOrigin = props.crossOrigin;

    if (!map) return;

    if (map._layers && map._layers[this.id]) {
      map._layers[this.id].setVisible(true);
      return;
    }

    var projection = map.getView().getProjection();
    var projectionExtent = projection.getExtent();
    var size = getWidth(projectionExtent) / 256;
    var resolutions = new Array(numberOfZoomResolutions);
    var matrixIds = new Array(numberOfZoomResolutions);

    for (var z = 0; z < numberOfZoomResolutions; ++z) {
      // generate resolutions and matrixIds arrays for this WMTS
      resolutions[z] = size / Math.pow(2, z);
      matrixIds[z] = projCode + ':' + z;
    }

    var params = {};

    if (useBaat && baatToken) {
      params.GKT = baatToken;
    }

    var tileLoadFunction = function tileLoadFunction(imageTile, src) {
      imageTile.getImage().src = useBaat && baatToken ? src + '&GKT=' + baatToken : src;
    };

    map._layers = map._layers || {};
    map._layers[this.id] = new TileLayer({
      opacity: opacity,
      minResolution: maxZoom && getResolution(maxZoom),
      maxResolution: minZoom && getResolution(minZoom),
      zIndex: zIndex,
      source: new WMTS({
        attributions: attributions,
        url: uri,
        urls: uris,
        layer: layerName,
        matrixSet: projCode,
        projection: projection,
        format: format,
        tileLoadFunction: tileLoadFunction,
        tileGrid: new WMTSTileGrid({
          origin: getTopLeft(projectionExtent),
          resolutions: resolutions,
          matrixIds: matrixIds
        }),
        style: style,
        crossOrigin: crossOrigin
      })
    });

    if (onPreCompose) {
      map._layers[this.id].on('precompose', onPreCompose);
    }
    if (onPostCompose) {
      map._layers[this.id].on('postcompose', onPostCompose);
    }

    this.mountLayer();
  };

  WmtsLayer.prototype.mountLayer = function mountLayer() {
    var map = this.props.map;

    if (!map) {
      setTimeout(this.mountLayer.bind(this), 200);
      return;
    }

    map.addLayer(map._layers[this.id]);
  };

  WmtsLayer.prototype.componentWillUnmount = function componentWillUnmount() {
    var map = this.props.map;

    map._layers[this.id].setVisible(false);
  };

  WmtsLayer.prototype.render = function render() {
    return null;
  };

  _createClass(WmtsLayer, [{
    key: 'id',
    get: function get() {
      return this.props.id;
    }
  }]);

  return WmtsLayer;
}(React.Component);

WmtsLayer.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The internal name of the layer
   */
  name: PropTypes.string,
  /**
   * A URL for the service
   */
  uri: PropTypes.string,
  /**
   * An array of URLs.
   */
  uris: PropTypes.arrayOf(PropTypes.string),
  /**
   * ID of the layer. Used for switching layers on and off instead of destroying layers.
   */
  id: PropTypes.string.isRequired,
  /**
   * Name of layers to be added from the source
   */
  layerName: PropTypes.string.isRequired,
  /**
   * Set to true to use BAAT authorization on layer
   */
  useBaat: PropTypes.bool,
  /**
   * Baat token used for authorization on BAAT services from the Norwegian Mapping Authority solutions.
   */
  baatToken: PropTypes.string,
  /**
   * Projection code, e.g EPSG:3857. Provided by EnsureMap
   */
  projCode: PropTypes.string,
  /**
   * Instance of OL map this component is bound to.
   */
  map: PropTypes.object,
  /**
   * Minimum zoom level
   */
  minZoom: PropTypes.number,
  /**
   * Maximum zoom level
   */
  maxZoom: PropTypes.number,
  /**
   * The z-index for layer rendering. At rendering time, the layers will be ordered, first by Z-index and then by position
   */
  zIndex: PropTypes.number,
  /**
   * Number of zoom levels supported by the service. Used for calculation of resolutions
   */
  numberOfZoomResolutions: PropTypes.number.isRequired,
  /**
   *
   */
  sizes: PropTypes.arrayOf(PropTypes.number),
  /**
   * Function that calculates resolutions based on zoom levels. Provided by ensureMap
   */
  getResolution: PropTypes.func,
  /**
   *
   */
  onPreCompose: PropTypes.func,
  /**
   *
   */
  onPostCompose: PropTypes.func,
  /**
   * Cross origin attribute for image loading. See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for details.
   */
  crossOrigin: PropTypes.string
} : {};
export default ensureMap(provideMapState(WmtsLayer));